<template>
    <div class="sales-filter" v-if="projectItems != null && salesFilterParams != null">

        <div class="section-title-new" v-if="routerName == 'home' || routerName == 'online-booking-details'">
            <h2 v-if="globalLang == ''">Жилые комплексы</h2>
            <h2 v-if="globalLang == 'kz/'">Тұрғын үй кешендері </h2>
            <h2 v-if="globalLang == 'en/'">residential complex </h2>
        </div>

        <div class="sales-filter-city sales-filter-default" v-if="routerName != 'favorite-projects' && routerName != 'online-booking-details' && !isMobileChecker">
            <ul>
                <li v-for="(item, index) in cityFilter" :key="index">
                    <a href="#" @click.prevent="filterByCity('desctop', item, 'filter')" :class="{active : salesFilterParams.cityActive === item}">{{cityFilterNames[index]}}</a>
                </li>
            </ul>
        </div>

        <div class="links-group">
            <div class="sales-filter-city-dropwdown"> <!-- Выпадашка городов -->
                <div class="curent-city" :class="{'open' : openDropInit}">
                    <a href="#" :class="{active : salesFilterParams.cityActive === 'all'}" @click.prevent="openDrop">
                        <span v-if="lang == ''">Все города</span>
                        <span v-if="lang == 'kz/'">Барлық қалалар</span>
                        <span v-if="lang == 'en/'">All cities</span>
                    </a>
                    <a href="#" :class="{active : salesFilterParams.cityActive === item}" v-for="(item, index) in cityFilter" :key="index" @click.prevent="openDrop">{{cityFilterNames[index]}}</a>
                    <div class="drop-icon">
                        <svgIcon name="arrow_drop" class="icon-svg"/>
                    </div>
                </div>
                <div class="city-dropdown" :class="{'open' : openDropInit}">
                    <ul>
                        <li>
                            <a href="#" :class="{active : salesFilterParams.cityActive === 'all'}" @click.prevent="filterByCity('desctop', 'all', 'filter'), openDropInit = false">
                                <span v-if="lang == ''">Все города</span>
                                <span v-if="lang == 'kz/'">Барлық қалалар</span>
                                <span v-if="lang == 'en/'">All cities</span>
                            </a>
                        </li>
                        <li v-for="(item, index) in cityFilter" :key="index">
                            <a href="#" @click.prevent="filterByCity('desctop', item, 'filter'), openDropInit = false" :class="{active : salesFilterParams.cityActive === item}">{{cityFilterNames[index]}}</a>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- <div class="link-to-map-page" v-if="routerName != 'sales-map' && routerName != 'favorite-projects'">
                <router-link to="/sales-map" @click.native="startLoader">
                    <span v-if="lang == 'kz/'">Картадағы кешендер</span>
                    <span v-else>Комплексы на карте</span>
                </router-link>
            </div> -->
            <div class="link-to-sales-page" v-if="routerName == 'home'">
                <router-link to="/sales" @click.native="startLoader">
                    <span v-if="lang == ''">Все жилые комплексы</span>
                    <span v-if="lang == 'kz/'">Барлық тұрғын үй кешендері</span>
                    <span v-if="lang == 'en/'">All residential complexes</span>
                </router-link>
            </div>
        </div>


        <div class="mobile-filter-city" v-if="isMobileChecker">
            <div class="select-in" :class="{'sant' : selected == 'sankt-peterburg'}">
                <select v-model="selected" v-if="routerName != 'favorite-projects' && isMobileChecker" @change="filterByCity('mobile', $event, 'filter')" id="select-sales-filter">
                    <option value="all" v-if="routerName != 'sales-map'">
                        <span v-if="lang == ''">Все города</span>
                        <span v-if="lang == 'kz/'">Барлық қалалар</span>
                        <span v-if="lang == 'en/'">All cities</span>
                    </option>
                    <option v-for="(item, index) in cityFilter" :value="item" :key="index">
                        <span>{{cityFilterNames[index]}}</span>
                    </option>
                </select>
                <div class="drop-icon">
                    <svgIcon name="arrow_drop" class="icon-svg"/>
                </div>
            </div>
            <div class="mobile-sales-links">
                <router-link to="/sales"><svgIcon name="sales-all-mobile" class="icon-all"/></router-link>
                <router-link to="/sales-map" v-if="routerName != 'sales-map'"><svgIcon name="pin-sales-mobile" class="icon-pin"/></router-link>
                <router-link to="/flats"><svgIcon name="filter-mobile" class="icon-all"/></router-link>
            </div>
        </div>

    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue';
    export default {
        name: 'sales-filter',
        props: ['title'],
        components: {
            svgIcon,
        },
        data () {
            return {
                selected: null,
                routerName: this.$router.history.current.name,
                cityFilterNames: [],
                cityFilter: [],
                themeFilter: [],
                themeActive: null,
                filterArr: [],
                saleStat: 0,
                openDropInit: false,
                lang: window.GlobalLang,
                globalLang: window.GlobalLang,
            }
        },
        computed: mapGetters({
            setup: 'loadPageSetUp',
            projectItems: 'loadProjectItems',
            projectItemsDefault: 'loadProjectItemsDefault',
            projectItemsFilter: 'loadProjectItemsFilter',
            isMobileChecker: 'loadIsMobileChecker',
            salesFilterParams: 'loadSalesFilterParams',
        }),
        methods: {
            buildFiterCity() {
                if (this.projectItemsFilter != null) {
                    this.cityFilter = [];
                    
                    var data = this.projectItemsFilter;
                    var i;
                    var n;
                    // console.log(data, 'test')
                    for (i = 0; i < data.length; i++) {
                        // console.log(data[i].project_name.slug, 'SLUG TEST')
                        this.cityFilter.push(data[i].city_name.slug);
                        this.cityFilterNames.push(data[i].city_name.name);
                    }

                    
                    this.cityFilter = this.uniqueElementsInArray(this.cityFilter);
                    this.cityFilterNames = this.uniqueElementsInArray(this.cityFilterNames);

                    if (this.globalLang == 'en/') {
                        this.cityFilterNames = this.cityFilter;
                    }

                    // console.log(this.cityFilter)
                    // console.log(this.cityFilterNames)
                }
                // console.log(this.cityFilter, this.cityFilterNames, 'cityyyy')

                // console.log(this.cityFilter, this.themeFilter);
            },
            uniqueElementsInArray(arr) {
                let result = [];
                for (let str of arr) {
                    if (!result.includes(str)) {
                        result.push(str);
                    }
                }
                return result;
            },
            filterByCity(param, event, type) {
                var city;
                // console.log(param, event, city, this.saleStat)
                if (param == 'desctop') {
                    city = event;
                } else {
                    if (type == 'filter') {
                        if (event != 'all') {
                            city = event.target.value;
                            // console.log(event, param, this.selected, event.target.value, 'asdasdas')
                        } else {
                            city = event;
                        }
                    } else {
                        if (event != 'all') {
                            city = event;
                            this.selected = city;
                            // console.log(event, param, this.selected, event.target.value, 'asdasdas')
                        } else {
                            city = 'all';
                            this.selected = 'all';
                        }
                    }
                    
                }
                // console.log(param, event, city, this.saleStat)
                this.$store.commit('setSalesFilterParams', {type : 'cityActive', data : city});
                this.$store.commit('setSalesFilterParams', {type : 'initFilter', data : true});
                // this.cityActive = city;
                // this.initFilter = true;

                // console.log(city, 'city')

                var local_url = window.location
                var cityUrl = new URL(window.location.href).searchParams.get('city');
                // var actionCode = new URL(window.location.href).searchParams.get('oobCode');
                // console.log(local_url, cityUrl);

                
                if (city != 'all' ) {
                    if (this.routerName == 'sales') {
                        var data = this.projectItemsDefault;

                        // console.log(city, 'adasdasdasd')
                        // Стандартный фильтр по городам
                        if (cityUrl == null && this.salesFilterParams.saleStat != 1) {
                            this.$store.commit('setSalesFilterParams', {type : 'saleStat', data : 1});
                            this.$store.commit('setSalesFilterParams', {type : 'cityActive', data : 'all'});
                            this.$store.commit('setSalesFilterParams', {type : 'initFilter', data : false});
                            this.$store.commit('filterProjectsItems', data);
                            this.$store.commit('setProjectFilCity', null);
                        } else if (cityUrl != null && this.salesFilterParams.saleStat != 1) {
                            this.$store.commit('setSalesFilterParams', {type : 'saleStat', data : 1});
                            this.$store.commit('setSalesFilterParams', {type : 'cityActive', data : cityUrl});
                            this.$store.commit('setSalesFilterParams', {type : 'initFilter', data : true});
                            var filteredItems = data.filter(item => {
                                return item.city_name.slug == cityUrl
                            })
                            this.$store.commit('filterProjectsItems', filteredItems);
                            this.$store.commit('setProjectFilCity', cityUrl);
                        } else {
                            var filteredItems = data.filter(item => {
                                return item.city_name.slug == city
                            })
                            this.$store.commit('setProjectFilCity', city);
                            this.$store.commit('filterProjectsItems', filteredItems);
                        }

                        // if (this.saleStat != 1 && cityUrl == null) {
                        //     this.saleStat = 1;
                        //     this.cityActive = null;
                        //     this.initFilter = false;
                        //     this.$store.commit('filterProjectsItems', data);
                        // } else if (cityUrl != null) {
                        //     var filteredItems = data.filter(item => {
                        //         return item.city_name.slug == cityUrl
                        //     })
                        //     this.$store.commit('filterProjectsItems', filteredItems);
                        // } else {
                        //     var filteredItems = data.filter(item => {
                        //         return item.city_name.slug == city
                        //     })
                        //     this.$store.commit('filterProjectsItems', filteredItems);
                        // }
                    } else {
                        var data = this.projectItemsDefault;
                        var filteredItems = data.filter(item => {
                            return item.city_name.slug == city
                        })
                        this.$store.commit('filterProjectsItems', filteredItems.slice(0, 12));
                        this.$store.commit('setProjectFilCity', city);
                    }
                } else {
                    this.$store.commit('setSalesFilterParams', {type : 'cityActive', data : city});
                    this.$store.commit('setSalesFilterParams', {type : 'saleStat', data : 1});
                    // this.saleStat = 1;
                    var data = this.projectItemsDefault;
                    this.$store.commit('setProjectFilCity', city);

                    if (this.routerName == 'sales') {
                        this.$store.commit('filterProjectsItems', data);
                    } else {
                        this.$store.commit('filterProjectsItems', data.slice(0, 12));
                    }
                }

                
                // if (filteredItems.length == 0) { // Фильтрации при условии что в выбранном городе нет объектов в продаже
                //     this.cityActive = 'almaty';
                //     var filteredItemsEmpty = data.filter(item => {
                //         return item.city_name.slug == 'almaty'
                //     });
                //     this.$store.commit('filterProjectsItems', filteredItemsEmpty);
                // }
                
                //  Фильтр для карты жилых комплексов
                if (this.routerName == 'sales-map' && this.setup != null) {
                    this.selected = city;
                    // console.log(this.setup, data, this.selected, city, '7777777777777')
                    var data = this.setup.regions_name;
                    var filteredCity = data.filter(item => {
                        return item.region_lat.slug == city
                    });
                    // console.log(data, filteredCity, 'CITY MAP');
                    this.$store.commit('filterMapCoords', filteredCity);
                    this.$store.commit('filterProjectsItemsMap', filteredItems);
                    // console.log(filteredCity[0].region, filteredItems, 'ITEMS MAP');

                    if (filteredItems.length == 0) { // Фильтрации при условии что в выбранном городе нет объектов в продаже
                        var filteredCityEmpty = data.filter(item => {
                            return item.region_lat.slug == 'almaty'
                        });
                        this.$store.commit('filterMapCoords', filteredCityEmpty);
                        this.$store.commit('filterProjectsItemsMap', filteredItemsEmpty);
                        // console.log(filteredCityEmpty, 'CITY MAP')
                    }
                }

                // Фильтр для избранных
                if (this.routerName == 'favorite-projects') {
                    var data = this.projectItemsDefault;
                    var favorite = localStorage.getItem('favorite_projects');
                    favorite = favorite ? favorite.split(',') : [];
                    var i;
                    var n;
                    var favoriteItems = [];
                    for (i=0; i < favorite.length; i++) {
                        for (n=0; n < data.length; n++) {
                            if (data[n].project_name.name == favorite[i]) {
                                favoriteItems.push(data[n])
                            }
                        }
                    }
                    this.$store.commit('filterProjectsItems', favoriteItems);
                }

                // Фильтр на главной если в городе нет жк для продаж
                if (this.routerName == 'home') {
                    var items = [];
                    var i;
                    // console.log('HOME FROM FILTER', data, filteredItems)
                    if (city != 'all') {
                        if (filteredItems.length == 0) {
                            this.$store.commit('setSalesFilterParams', {type : 'cityActive', data : null});
                            var almatyItem = data.filter(item => {
                                return item.city_name.slug == 'almaty'
                            });
                            var astanaItem = data.filter(item => {
                                return item.city_name.slug == 'nur-sultan'
                            });

                            for (i=0; i < 4; i++) {
                                items.push(almatyItem[i]);
                                items.push(astanaItem[i]);
                            }
                            // console.log(almatyItem, items);
                            this.$store.commit('filterProjectsItems', items);
                        }
                    }
                }
                this.animateCards();
                // } else {
                //     console.log(param, this.selected, event.target.value, 'asdasdas')
                // }
            },
            animateCards() {
                this.$store.commit('cardAnimateSet', false);
                setTimeout(()=>{
                    this.$store.commit('cardAnimateSet', true);
                },50);
            },
            initFilterCityByPageLoad() {
                // console.log(this.currentCity, 'sales_filter')
                if (this.routerName == 'sales-map') {
                    if (this.isMobileChecker) {
                        this.filterByCity('mobile', 'almaty', 'default');
                    } else {
                        this.filterByCity('desctop', 'almaty', 'default');
                    }
                } else {
                    if (this.isMobileChecker) {
                        this.filterByCity('mobile', this.salesFilterParams.cityActive, 'default');
                    } else {
                        this.filterByCity('desctop', this.salesFilterParams.cityActive, 'default');
                    }
                }
                
                // if (this.currentCity.length && this.projectItemsFilter != null) {
                // }
            },
            startLoader() {
                if (this.routerName == 'home') {
                    this.$parent.$parent.$parent.$refs.topProgress.start();
                } else {
                    this.$parent.$parent.$refs.topProgress.start();
                }
            },
            openDrop() {
                this.openDropInit = !this.openDropInit;
            }
        },
        
        beforeCreate() {
        },
        created () {
        },
        mounted () {
            this.buildFiterCity();
            this.initFilterCityByPageLoad();
            this.$store.watch(
                (state) => state.projectItemsFilter,
                (newValue) => {
                    this.buildFiterCity();
                    this.initFilterCityByPageLoad();
                }
            )
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/sales-filter/sales-filter.scss';
    @import '@/styles/respond/sales/respond-sales-filter.scss';
</style>